module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAABVklEQVR42u3Qu0oEQRBG4VG83y/7br7OBgYmhoaGxiKiiCKKKIqiqC90DNxgmempqe6u7k3qDys5H9U0iaO1pvYc4AAHOMABDnCAAxzgAAc4oACAAxZrABhxxEL3PAbO9YRUACN+gDPmu3mAC5ZKAiZ5gFPmunmASx0hBTCVBzgJ5QGuWC4BaOUBjkN5gOthQiwgkAc4DAPghhVLQE8exn0/gFtWrQBivukn3EkEPWAwLxDuWcsFqPIC4YH1HIA6LxAewwQNICovEJ7YSAFE5wXCM5uxgKS8QHhpE2RAcl4gvLKlBWTlBcIb2xpAdl4gvLMzBDDJC4QPdiWAWV4gfP4TQgDTvED4Yi8EMM8LhG/2O7cSeYHQjf0WyQsEzSzyGQSrfCLBMp9AsM5HEkrkIwil8kpCybyCUDo/QKiRFwi18j2EmvkAoXa+RZhFfoowq/yEkJn/A0plqpkctX4EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/arrows/white-2x.png
// module id = 166
// module chunks = 95715928098905 173670457132349